import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WarningBoxComponent } from 'src/app/components';
import { BehaviorSubject } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { ChargeMasterApiService } from 'src/app/services/domain_code/charge-master-api.service';
import { BackendListModel } from 'src/app/models/common/list.model';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { ChargeMasterModel, IChargeMasterModel } from 'src/app/models/Charge_Master_Model/charge-master';
import { DomainCodeApiService } from 'src/app/services/domain_code/domain-code-api.service';
import { DomainCode } from 'src/app/models/common/model';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { External_Mappings } from 'src/app/models/Charge_Master_Model/external-source-charge-mapping.model';
import { MatStepper } from '@angular/material/stepper';
import { IChargeCategory } from '../charge-category-form/charge-category.model';
import { IChargeGroup } from 'src/app/models/Charge_Master_Model/charge-group';


@Component({
  selector: 'logzy-charge-form',
  templateUrl: './charge-form.component.html',
  styleUrls: ['./charge-form.component.scss']
})
export class ChargeFormComponent implements OnInit {
  @Input()
  isEditable: boolean;
  wasedit: boolean;
  isLinear: boolean = true;
  isStepOneComplete: boolean = false;

  @Output()
  closeForm = new EventEmitter<IChargeMasterModel>();

  @Output()
  isEditableChange = new EventEmitter<boolean>();

  @Output() searchData = new EventEmitter<string>();

  chargeObject: ChargeMasterModel;

  @Input()
  bindCategory = new BehaviorSubject(null);

  @Input()
  bindGroup = new BehaviorSubject(null);

  @ViewChild('stepper') stepper: MatStepper;

  @ViewChild('mySidepanel')
  mySidepanel!: any;

  charge_url = `${ApiRoutes.ChargeMaster}charge_master/?charge_head=::search::`
  charge_category_url = `${ApiRoutes.ChargeMaster}charge_category_master/?charge_category_name=::search::`
  charge_group_url = `${ApiRoutes.ChargeMaster}charge_group/?name=::search::`
  hsn_url = `${ApiRoutes.HSN}code/?search=::search::`


  dd_charge_category: BackendListModel<IChargeCategory>;
  // dd_HsnSacNumber: BackendListModel<HSNSAC>
  dd_chargeMaster: MatTableDataSource<any>;
  charge_nature: BackendListModel<DomainCode>;
  UOM_Charge: BackendListModel<DomainCode>;
  dd_ChargeGroup: BackendListModel<IChargeGroup>

  @Output()
  newChargeCategory = new EventEmitter<boolean>();

  @Output()
  newChargeGroup = new EventEmitter<boolean>();

  department_url = `${ApiRoutes.Company}department/?name=::search::`;
  userListUrl = `${ApiRoutes.Company}user_list/?search=::search::&is_internal=1`;
  ext_app_listUrl = `${ApiRoutes.ChargeMaster}external_app_master/?search=::search::`;
  displayColumns = ['department', 'users'];
  externalMappingDisplayColumns = ['app_name', 'charge_code', 'description'];
  disableUserField: boolean = true;
  mappingErrorObj: any = {};
  notGettingDragged: boolean = false;
  mouseDown: boolean = false;

  constructor(private _snackBar: MatSnackBar, private _chargemasterservice: ChargeMasterApiService,
    private domainService: DomainCodeApiService, public dialog: MatDialog, private route: ActivatedRoute, private router: Router
  ) {
  }

  ngOnInit(): void {
    this.isLinear = true;
    this.isStepOneComplete = false;

    this.chargeObject = new ChargeMasterModel();
    this.getChargeCategory();
    this.getChargeGroup();
    this.getUOMCharge();
    this.getChargeNature();
    this.getChargeMaster();
    this.route.queryParams.subscribe(params => {
      if ('id' in params) {
        this.getChargebyID(params['id']);
      }
    });

    this.bindCategory.subscribe(item => {
      if (item != null) {
        this.chargeObject.charge_category = { ...item };
      }
    });

    this.bindGroup.subscribe(item => {
      if (item != null) {
        this.chargeObject.charge_group = { ...item };
      }
    });
  }


  getChargebyID(id) {
    this._chargemasterservice.getChargeMasterbyID(id).subscribe(response => {
      this.chargeObject.savePayloadToModel(response);
      this.isLinear = false;
      // this.isStepOneComplete = true;
      this.isEditable = false;
    })
  }

  closeChargeGroupSidePanel() {
    this.resetComponent();
    this.mySidepanel.nativeElement.style.width = "0";
  }

  catchError(error) {
    if (error.status >= 500) {
      this._snackBar.open("Something went wrong!! Please try again after sometime.", 'Close', {
        verticalPosition: 'top',
        duration: 3000,
      });
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.chargeObject.setErrors(error.error);
      return error;
    }
  }

  getChargeCategory() {
    this._chargemasterservice.getChargeCategory().subscribe(response => {
      this.dd_charge_category = response;
    })
  }

  // getHSNSACNumber() {
  //   this._chargemasterservice.getHSNSACnumber().subscribe(response => {
  //     this.dd_HsnSacNumber = response;
  //   })
  // }

  getChargeMaster() {
    this._chargemasterservice.getChargeMaster().subscribe(response => {
      this.dd_chargeMaster = new MatTableDataSource(response.results);
    })
  }

  getChargeNature(grp = 'ChargeNature') {
    this.domainService.getByGroup(grp).subscribe(response => {
      this.charge_nature = response;
    })
  }

  getUOMCharge(grp = 'UOMCharge') {
    this.domainService.getByGroup(grp).subscribe(response => {
      this.UOM_Charge = response;
    })
  }

  getChargeGroup() {
    this._chargemasterservice.getChargeGroup().subscribe(response => {
      this.dd_ChargeGroup = response;
    })
  }

  _postCharge(data) {
    this._chargemasterservice.postChargeMaster(data).subscribe({
      next: response => {
        this._snackBar.open("Charge saved successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.chargeObject.savePayloadToModel(response);

        this.isStepOneComplete = true;
        setTimeout(() => {
          this.stepper.next();
        }, 10);
        return response;
      },
      error: error => {
        return this.catchError(error);
      }
    });
  }

  editCharge(element) {
    this.router.navigate([], {
      queryParams: {
        'id': element.id,
      },
      queryParamsHandling: 'merge'
    });
  }

  openWarningDialog(label: string, temp) {
    this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      data: { subTitle: ``, description: temp }
    })
  }

  _putCharge(id, data) {
    this._chargemasterservice.updateChargeMaster(id, data).subscribe({
      next: response => {
        this._snackBar.open("Charge updated successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.chargeObject.savePayloadToModel(response);

        this.stepper.next();
        return response;
      },
      error: error => {
        return this.catchError(error);
      }
    });
  }

  saveCharge() {
    let payload = this.chargeObject.getStepOneSavePayload();

    if (this.chargeObject.checkStepOneForErrors()) {
      if (payload.id != null) {
        this._putCharge(payload.id, payload);
      } else {
        this._postCharge(payload);
      }
    }
  }

  setChargeGroup(event) {
    if (event != null) {
      if (event.id != null) {
        this.chargeObject.charge_group = event;
      } else if (event.name) {
        this.newChargeGroup.emit(event.name)
      }
    }
  }
  onMouseMove(e: any) {
    this.notGettingDragged = true
  }
  ifDown() {
    this.mouseDown = true;
    this.notGettingDragged = false;
  }
  wasEdit() {
    if (this.mouseDown) {
      if (this.notGettingDragged == false) {
        this.isEditable = true;
        this.isEditableChange.emit(true);
        this.chargeObject.resetErrors();
        this.mappingErrorObj = {};
      } else if (this.notGettingDragged) {
        this.notGettingDragged = false;
      }
    }
  }
  // isEditTure() {
  //   this.isEditable = true;
  // }
  resetComponent() {
    this.chargeObject = new ChargeMasterModel();
    this.stepper.reset();
    this.isLinear = true;
    this.isStepOneComplete = false;
    this.mappingErrorObj = {};
  }

  closeChargeForm(chargeObject: IChargeMasterModel) {  // Send null here to close without saving charge. For eg: cancel button
    this.isEditable = false;
    this.closeForm.emit(chargeObject);
    this.closeChargeGroupSidePanel();
    this.resetComponent();
    this.router.navigate([], {
      queryParams: {
        'id': null,
      },
      queryParamsHandling: 'merge'
    });
  }

  closeChargePanel() {  // Send null here to close without saving charge. For eg: cancel button
    this.isEditable = false;
    this.closeForm.emit();
    this.closeChargeGroupSidePanel();
    this.resetComponent();
    this.router.navigate([], {
      queryParams: {
        'id': null,
      },
      queryParamsHandling: 'merge'
    });
  }

  //for Edit Cahrge
  clickedChargeToEdit;
  editChargeMaster(element) {
    this.clickedChargeToEdit = element;
    this.openWarningDialogEdit("Are you sure Edit this Charge?", "No", "Yes");
  }
  openWarningDialogEdit(label: string, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      data: { subTitle: label, parent: this, label1: action1, label2: action2, negativeAction: this.negativeResponseEdit, positiveAction: this.positiveResponseEdit }
    })
    dialogRef.afterClosed();
  }

  positiveResponseEdit(parent) {
    parent.editCharge(parent.clickedChargeToEdit);
  }

  negativeResponseEdit(parent) {
    parent.clickedChargeToEdit = null;
    return;
  }

  //For inactive Currency
  clickedChargeToinActive;
  inActiveChargeMaster(element) {
    this.clickedChargeToinActive = element;
    this.openWarningDialoginActive("Making Charge Inactive will SOFT Delete it, which might impact some transactions. Do you still want to continue?", "No", "Yes");
  }
  openWarningDialoginActive(label: string, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      data: { subTitle: label, parent: this, label1: action1, label2: action2, negativeAction: this.negativeResponseinActive, positiveAction: this.positiveResponseinActive }
    })
    dialogRef.afterClosed();
  }

  positiveResponseinActive(parent) {
    parent.chargeObject.is_active = false;
  }

  negativeResponseinActive(parent) {
    parent.chargeObject.is_active = true;
    return;
  }


  setChargeCategory(event) {
    if (event != null) {
      if (event.id != null) {
        this.chargeObject.charge_category = event;
      } else if (event.name) {
        this.newChargeCategory.emit(event.name)
      }
    }
  }

  showAllDepartments(event) {
    if (event.flag) {
      this.chargeObject.departments = event.option;
    }
  }

  showAllUsers(event) {
    if (event.flag) {
      this.chargeObject.exclude_users = event.option;
    }
  }

  setUserUrl(event) {
    this.chargeObject.departments = event;
    if (event == null || event.length == 0) {
      this.userListUrl = `${ApiRoutes.Company}user_list/?search=::search::&is_internal=1`;
      this.chargeObject.exclude_users = [];
      this.disableUserField = true;
      return;
    }

    if (event.length > 0) {
      let str = ''
      for (let i = 0; i < event.length; i++) {
        str = `${str}${event[i].id}${i == event.length - 1 ? '' : ','}`;
      }
      this.userListUrl = `${ApiRoutes.Company}user_list/?search=::search::&is_internal=1&department=${str}`;
      this.disableUserField = false;
    }
  }

  addESCIMapping() {
    this.chargeObject.external_mappings.push(new External_Mappings());
  }

  removeESCIMapping(idx) {
    this.chargeObject.external_mappings.splice(idx, 1);
  }

  setESCIDescription(event, idx) {
    if (event != null) {
      this.chargeObject.external_mappings[idx].description = event.description;
    }
    this.chargeObject.external_mappings[idx].app_name = event;
  }

  saveUserChargeMapping() {
    let payload = this.chargeObject.getUserChargeSavePayload();

    this._chargemasterservice.putUserChargeMapping(this.chargeObject.id, payload).subscribe({
      next: res => {
        this._snackBar.open("User Charge mapping saved successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.stepper.next();
      },
      error: err => {
        return this.catchError(err);
      }
    });
  }

  saveExternalChargeMapping() {
    let payload = this.chargeObject.getESCISavePayload();

    let noPayloadError: boolean = true;

    for (let i = 0; i < this.chargeObject.external_mappings.length; i++) {
      this.externalMappingDuplicateAppNameErrorCheck(this.chargeObject.external_mappings[i], i);
      noPayloadError = noPayloadError && this.chargeObject.external_mappings[i].checkMapErrors();
    }

    if (noPayloadError) {
      this._chargemasterservice.postExternalSourceChargeIDMapping(this.chargeObject.id, payload.external_mappings).subscribe({
        next: res => {
          this._snackBar.open("External Source Charge-ID mapping saved successfully!", 'Close', {
            verticalPosition: 'top',
            duration: 2000,
          });

          this.closeChargePanel();
        },
        error: err => {
          if (err.status >= 500) {
            this._snackBar.open("Something went wrong!! Please try again after sometime.", 'Close', {
              verticalPosition: 'top',
              duration: 3000,
            });
            return err;
          } else if (err.status > 399 && err.status < 500) {
            let errKeys = Object.keys(err.error)
            for (let item in errKeys) {
              this.chargeObject.external_mappings[Number(item)].setMappingErrors(err.error[item])
            }
            return err;
          }
        }
      });
    }
  }

  externalMappingDuplicateAppNameErrorCheck(mapObj, idx) {
    for (let i = 0; i < this.chargeObject.external_mappings.length; i++) {
      if (idx != i && mapObj.app_name.id == this.chargeObject.external_mappings[i].app_name.id) {
        this.chargeObject.external_mappings[i].mapErr.app_name = ['Duplicate entries are prohibited'];
      }
    }
  }
}
